import React, { useState, useCallback, useEffect } from "react";
import { Button, message, Form, Input, Row, Col } from 'antd';

const { TextArea } = Input;

const DEFAULT_WEBSITE_TEXTS = {
    site_name: '',
    tagline: '',
    hero_heading: '',
    hero_subtext: '',
    contact_section_title: 'Contact Us',
    contact_phone_label: 'Phone',
    contact_email_label: 'Email',
    address_label: 'Address',
    footer_about: '',
    copyright_text: '',
};

const TEXT_FIELDS = [
    { label: 'Site name', name: 'site_name', placeholder: 'Your travel company name' },
    { label: 'Tagline', name: 'tagline', placeholder: 'Short tagline below logo' },
    { label: 'Hero heading', name: 'hero_heading', placeholder: 'Main banner heading' },
    { label: 'Hero subtext', name: 'hero_subtext', placeholder: 'Banner subtext', component: 'textarea' },
    { label: 'Contact section title', name: 'contact_section_title', placeholder: 'Contact Us' },
    { label: 'Contact phone label', name: 'contact_phone_label', placeholder: 'Phone' },
    { label: 'Contact email label', name: 'contact_email_label', placeholder: 'Email' },
    { label: 'Address label', name: 'address_label', placeholder: 'Address' },
    { label: 'Footer about text', name: 'footer_about', placeholder: 'Short about text', component: 'textarea' },
    { label: 'Copyright text', name: 'copyright_text', placeholder: '© 2025 Your Company' },
];

export const OperatorWebsiteTextsTab = ({ initialValues, onValuesChange, active }) => {
    const [form] = Form.useForm();
    const [saving, setSaving] = useState(false);
    const [values, setValues] = useState(initialValues || DEFAULT_WEBSITE_TEXTS);

    useEffect(() => {
        if (active) form.setFieldsValue(values);
    }, [active, values, form]);

    const handleSave = useCallback(() => {
        form.validateFields().then((formValues) => {
            setSaving(true);
            setValues((prev) => ({ ...prev, ...formValues }));
            if (onValuesChange) onValuesChange(formValues);
            setTimeout(() => {
                setSaving(false);
                message.success('Texts saved successfully. Backend integration can be wired here.');
            }, 400);
        }).catch(() => {});
    }, [form, onValuesChange]);

    return (
        <div className="tab-content tab-content-texts">
            <p className="tab-description">
                Edit headings, taglines, contact labels and footer text shown on the customer website.
            </p>
            <Form
                form={form}
                layout="vertical"
                initialValues={values}
                onValuesChange={(_, formValues) => {
                    setValues((prev) => ({ ...prev, ...formValues }));
                    if (onValuesChange) onValuesChange(formValues);
                }}
                className="config-form texts-form"
            >
                <Row gutter={[24, 16]}>
                    {TEXT_FIELDS.map(({ label, name, placeholder, component }) => (
                        <Col xs={24} md={component === 'textarea' ? 24 : 12} key={name}>
                            <Form.Item name={name} label={label}>
                                {component === 'textarea' ? (
                                    <TextArea rows={3} placeholder={placeholder} />
                                ) : (
                                    <Input placeholder={placeholder} />
                                )}
                            </Form.Item>
                        </Col>
                    ))}
                </Row>
                <div className="form-actions">
                    <Button type="primary" size="large" onClick={handleSave} loading={saving}>
                        Save Texts
                    </Button>
                </div>
            </Form>
        </div>
    );
};
